import React, { ReactNode, useEffect, useRef, useState } from 'react'
import { OverlayTrigger, Tooltip as BTooltip } from 'react-bootstrap'
import styles from './Tooltip.module.sass'

const SHOW_DELAY = 50
const HIDE_DELAY = 50

export interface Props {
  label: string | ReactNode
  id: string
  triggerClassName?: string
  className?: string
  pos?: 'top' | 'right' | 'bottom' | 'left'
  children?: any
}
const Tooltip = (mainProps: Props) => {
  const {
    label = '',
    id = '',
    pos = 'top',
    triggerClassName = '',
    className = '',
    children = null,
  } = mainProps

  const [show, setShow] = useState(false)
  const toggleTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const clearToggleTimeout = () => {
    if (toggleTimeoutRef.current) {
      clearTimeout(toggleTimeoutRef.current)
      toggleTimeoutRef.current = null
    }
  }

  const queueVisibility = (nextShow: boolean) => {
    clearToggleTimeout()
    toggleTimeoutRef.current = setTimeout(
      () => {
        setShow(nextShow)
        toggleTimeoutRef.current = null
      },
      nextShow ? SHOW_DELAY : HIDE_DELAY
    )
  }

  const handleShow = () => queueVisibility(true)
  const handleHide = () => queueVisibility(false)

  useEffect(() => () => clearToggleTimeout(), [])

  const renderTooltip = (props: any) => (
    <BTooltip
      id={id}
      className={`${styles.root} ${className}`}
      onMouseEnter={handleShow}
      onMouseLeave={handleHide}
      onFocus={handleShow}
      onBlur={handleHide}
      {...props}
    >
      <div dangerouslySetInnerHTML={{ __html: label }} className={styles.content} />
    </BTooltip>
  )

  return (
    <OverlayTrigger placement={pos} trigger={[]} show={show} overlay={renderTooltip}>
      <button
        aria-describedby={id}
        className={`${styles.trigger} ${triggerClassName}`}
        onMouseEnter={handleShow}
        onMouseLeave={handleHide}
        onFocus={handleShow}
        onBlur={handleHide}
      >
        {children}
      </button>
    </OverlayTrigger>
  )
}
export default Tooltip
